// services for user api
import axios from 'axios'
// import global settings
import baseConf from '@/Base'

var instance = axios.create({
  baseURL: baseConf.urlApi,
  timeout: 3000
})

const apiAnuncios = {
  listarAnunciosMainMovTorneo: function (tipo, torneo) {
    return instance.get('/api/main-mov/anuncios-torneo/' + tipo + '/' + torneo + '/', {
      headers: {
        'Authorization': 'Token ' + localStorage.getItem('token')
      }
    })
  },
  listarAnunciosTipo: function (tipo, num) {
    return instance.get('/api/listar/anuncios-tipo/' + tipo + '/' + num + '/')
  },
  listarAnunciosCompetition: function (compe) {
    return instance.get('/api/listar/anuncios-competition/' + compe + '/')
  },
  listarAnunciosTeam: function (tipo, num, team) {
    return instance.get('/api/listar/anuncios-team/' + tipo + '/' + num + '/' + team + '/')
  },
  listaProductosAfiliados: function (page, marca) {
    return instance.get('/api/afiliados/lista-populares/?page='+page+ '&marca=' + marca)
  },
}

export function createAdsPublicCompe(data) {
  // consulta al servidor
  return instance.post('/api/anuncios/create/new-ads/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token'),
      'Content-Type': 'multipart/form-data',
    }
  })
}

export function registerNoAdsPublicCompe(data) {
  // registra que no se publiquen anuncios en una pagina de competicion
  // consulta al servidor
  return instance.post('/api/anuncios/create/no-public-compe/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function createAdsMovPublicTorneo(data) {
  // anuncios estilo mov en un periodo de tiempo y para un torneo
  // consulta al servidor
  return instance.post('/api/anuncio-basico/create/public-ads/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function registerNoAdsMovPublicTorneo(data) {
  // bloque mostrar anuncios estilo mov en un periodo de tiempo y para un torneo
  // consulta al servidor
  return instance.post('/api/anuncio-basico/create/no-public-torneo/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function listAnunciosCompeUser(page) {
  // lista anuncios de un usuario
  // consulta al servidor
  return instance.get('/api/anuncio-compe/list/by-organizer/?page='+page, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function listAnunciosBasicoTorneoUser(page) {
  // lista anuncios de un usuario
  // consulta al servidor
  return instance.get('/api/anuncio-basico/list/by-organizer/?page='+page, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function updateDataAdsCompetition(data) {
  // actualzia informacion basica de anuncio en competicion
  // consulta al servidor
  return instance.post('/api/anuncio-compe/update-data/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function updateDataAdsBasicoTorneo(data) {
  // modifica anuncio basico torneo
  // consulta al servidor
  return instance.post('/api/anuncio-basico/update-data/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function listAdsTeamMain() {
  // modifica anuncio basico torneo
  // consulta al servidor
  return instance.get('/api/anuncio-ds/team/public-ads/', {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}
export default apiAnuncios
